import React, { useEffect, useState } from "react";
import { HeaderStyled } from "./HeaderStyled";
import Flex from "../../UI/Flex";
import { FLEX_ALIGN, JUSTIFY_CONTENT } from "../../entities/Flex";
import { getLogoFromTenant } from "../../utils/tenant";
import { HeaderProps } from "../../entities/Header";
import LanguageSelect from "../Language/LanguageSelect";
import AsyncSearch from "../AsyncSearch";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { TEST_ID } from "../../shared/testid";

const Header: React.FC<HeaderProps> = ({ credentials, url }: HeaderProps) => {
  const [headerIsFixed, setHeaderIsFixed] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      setHeaderIsFixed(window.scrollY > 1);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <HeaderStyled className={headerIsFixed ? "sticky" : ""}>
      <Flex
        styles={{
          align: FLEX_ALIGN.CENTER,
          justify: JUSTIFY_CONTENT.SPACE_BETWEEN,
        }}
      >
        <div className="header-left">
          <a
            href={url}
            target="_blank"
            rel="nofollow noreferrer"
            className="header-logo"
            data-testid={TEST_ID.HEADER.LOGO}
          >
            <img
              src={getLogoFromTenant(credentials.webshopDesigns)}
              alt={credentials.tenant.name}
            />
          </a>
        </div>

        <div className="header-right">
          <LanguageSelect />
          <AsyncSearch />
        </div>
      </Flex>
      <Breadcrumbs />
    </HeaderStyled>
  );
};

export default Header;
